import { Injectable, inject, signal } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  readonly #isMobile = signal<boolean>(this.checkIsMobile());
  readonly isMobile = this.#isMobile.asReadonly();

  constructor() {
    window.addEventListener('resize', () => {
      this.#isMobile.set(this.checkIsMobile());
    });
  }

  private checkIsMobile(): boolean {
    return window.innerWidth <= 600;
  }
}
